import React from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header: React.FC = () => {
  return (
    <header className="header">
      <div className="header-left">
        <Link to="/" className="logo">CheckifAI</Link>
      </div>
      <nav className="header-nav">
        <a href="https://app.checkifai.nl/" target="_blank" rel="noopener noreferrer">Product</a>
        <a href="/pricing">Pricing</a>
        <a href="#resources">Resources</a>
      </nav>
      <div className="header-actions">
        <button className="btn-primary" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Start Free Trial</button>
        <button className="btn-secondary" onClick={() => window.open('https://app.checkifai.nl/', '_blank')}>Login</button>
      </div>
    </header>
  );
};

export default Header;
